<template>
  <b-container>
    <b-row class="justify-content-md-center">
      <div class="card" style="min-width: 70rem;">
        <div class="card-header card-header-flex" style="width: 100%;">
          <template v-if="!loading && periodsList.length > 0">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0" style="min-width: max-content;">Reporte Periodo {{ periodSelected.name }}</h5>
            </div>
            <div v-if="generatingReport" class="d-flex flex-column justify-content-center mr-2">
              <b-spinner label="Spinning"></b-spinner>
            </div>
            <div class="d-flex flex-column justify-content-center mr-2">
              <b-button block squared variant="outline-secondary" class="btn-rounded" :disabled="generatingReport" v-on:click="downloadGradesReport()">
                <i class="fe fe-download mr-1"></i>
                Descargar reporte del periodo
              </b-button>
            </div>
            <div v-if="hasChildren && children.length > 1" class="d-flex flex-column justify-content-center mr-2">
              <a-dropdown placement="bottomRight" :trigger="['click']">
                <button type="button" class="btn btn-light">
                  <i class="fa fa-refresh" />
                  Cambiar de estudiante
                </button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="child in children" v-bind:key="child.id">
                    <div v-on:click="changeChild(child.idChild)">
                      <i class="fa fa-user mr-1" />
                      {{ child.fullName }}
                    </div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <a-dropdown placement="bottomRight" :trigger="['click']">
                <button type="button" class="btn btn-light">
                  <i class="fa fa-ellipsis-v" />
                </button>
                <a-menu slot="overlay">
                  <template v-for="(period) in periodsList">
                    <a-menu-item v-if="period !== null" v-on:click="selectPeriod(period)" v-bind:key="period.id">
                      <div>Consultar periodo {{ period.name }}</div>
                    </a-menu-item>
                  </template>
                </a-menu>
              </a-dropdown>
            </div>
          </template>
          <template v-if="loading">
            <div class="d-flex flex-column justify-content-center mr-auto" style="width: 50%;">
              <b-skeleton></b-skeleton>
            </div>
            <div class="d-flex flex-column justify-content-center mr-2" style="width: 20%;">
              <b-skeleton></b-skeleton>
            </div>
          </template>
          <template v-if="!loading && periodsList.length < 1">
            <div>
              <div class="p-5 font-size-30">
                <div class="font-weight-bold mb-3">Periodos académicos finalizados</div>
                <div>Pronto habilitaremos nuevamente este módulo para que puedas revisar y descargar tus notas.</div>
                <router-link to="/" class="btn btn-outline-primary width-100">Home</router-link>
              </div>
            </div>
          </template>
        </div>
        <div class="card-body">
          <div v-if="!loading && periodsList.length > 0">
            <table role="table" class="table b-table table-bordered table-sm" v-cloak>
              <tbody>
                <tr>
                  <td><b>Estudiante</b>: {{ report.student.fullName }}</td>
                  <td><b>Identificación</b>: {{ report.student.nip }}</td>
                  <td rowspan="3" class="justify-content-center" style="width: 200px;text-align: center;">
                    <img :src="`${report.student.pathAvatar}?tr=w-200`"
                    @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                    style="width:100%; max-width:150px;">
                  </td>
                </tr>
                <tr>
                  <td><b>Código</b>: {{ report.student.id }}</td>
                  <td><b>Grupo</b>: {{ report.group.name }}</td>
                </tr>
                <tr>
                  <td><b>Calendario</b>: A <b>Año escolar:</b> {{ currentYear.name }}</td>
                  <td><b>Periodo</b>: {{ periodSelected.name }}</td>
                </tr>
              </tbody>
            </table>

            <div v-if="report.student.SBG.length > 0">
              <table role="table" class="table b-table table-bordered table-sm" v-cloak>
                <tbody>
                  <tr>
                    <td style="background-color: #ededed; min-width: 80px"><b>Nivel 1</b></td>
                    <td>El estudiante muestra poco o ningún dominio del criterio (yo puedo) y a pesar del constante apoyo y seguimiento no
alcanza los objetivos propuestos. </td>
                  </tr>
                  <tr>
                    <td style="background-color: #ededed"><b>Nivel 2</b></td>
                    <td>El estudiante demuestra dominio parcial del criterio (yo puedo) pero aún no lo puede aplicar o desarrollar de manera
autónoma.</td>
                  </tr>
                  <tr>
                    <td style="background-color: #ededed"><b>Nivel 3</b></td>
                    <td>El estudiante demuestra dominio básico del criterio (yo puedo), cumple las expectativas mínimas requeridas y
puede aplicar o desarrollar de manera independiente los objetivos propuestos.</td>
                  </tr>
                  <tr>
                    <td style="background-color: #ededed"><b>Nivel 4</b></td>
                    <td>El estudiante demuestra dominio completo del criterio (yo puedo), demuestra autonomía excediendo las
expectativas mínimas requeridas.</td>
                  </tr>
                  <tr>
                    <td style="background-color: #ededed"><b>Nivel 5</b></td>
                    <td>El estudiante demuestra dominio y aplicación total del criterio, interioriza el yo puedo de manera natural logrando
desarrollarlo de manera independiente y sin errores.</td>
                  </tr>
                </tbody>
              </table>
              <div v-for="(sbg) in report.student.SBG" :key="sbg.id">
                <table role="table" class="table b-table table-bordered table-sm" v-cloak v-if="isVisible(sbg)">
                  <thead style="background-color: #ededed">
                    <tr>
                      <td colspan="3"><b>Docente</b>: {{sbg.teacherName}} <br> <b>Asignatura</b>: {{sbg.name}}</td>
                    </tr>
                    <tr>
                      <td><b>Dimensión</b></td>
                      <td><b>Yo puedo</b></td>
                      <td style="text-align: center;"><b>Nivel</b></td>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="iCanList in sbg.iCanListByStudent">
                      <tr v-for="(i, index) in iCanList.data" v-bind:key="i.id">
                        <td style="vertical-align: middle; text-align: center;" v-if="index==0" :rowspan="iCanList.data.length"><b>{{iCanList.name}}</b></td>
                        <td>{{i.description}}</td>
                        <td style="text-align: center; vertical-align: middle;">{{i.level}}</td>
                      </tr>
                    </template>
                    <template v-if="sbg.indicators.length > 0">
                      <tr style="background-color: #ededed">
                        <td colspan="2"><b>Indicadores de desempeño</b></td>
                        <td style="text-align: center;"><b>Tipo</b></td>
                      </tr>
                      <tr v-for="indicator in sbg.indicators" v-bind:key="indicator.id">
                        <td colspan="2">{{indicator.description}}</td>
                        <td style="width: 15%; text-align: center; vertical-align: middle;">{{indicator.type}}</td>
                      </tr>
                    </template>
                    <template v-if="sbg.hasObservation">
                      <tr>
                        <td style="background-color: #ededed"><b>Observación:</b></td>
                        <td colspan="2">{{sbg.observation}}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="report.student.TBG.length > 0">
              <table role="table" class="table b-table table-bordered table-sm" v-cloak>
                <thead style="background-color: #ededed">
                  <tr>
                    <td><b>Asignatura</b></td>
                    <td><b>Docente</b></td>
                    <td><b>Definitiva</b></td>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(subject) in report.student.TBG">
                    <tr v-if="!subject.isException" v-bind:key="subject.id">
                      <td>{{subject.name}}</td>
                      <td>{{subject.teacherName}}</td>
                      <td style="text-align: center;vertical-align: middle;">{{subject.finalGrade}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <template v-for="(tbg) in report.student.TBG">
              <div v-if="tbg.hasIndicators || tbg.hasObservation" :key="tbg.id">
                <table role="table" class="table b-table table-bordered table-sm" v-cloak>
                  <thead style="background-color: #ededed">
                    <tr>
                      <td colspan="3"><b>Docente</b>: {{tbg.teacherName}} <br> <b>Asignatura</b>: {{tbg.name}}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="tbg.indicators.length > 0">
                      <tr style="background-color: #ededed">
                        <td colspan="2"><b>Indicadores de desempeño</b></td>
                        <td style="text-align: center;"><b>Tipo</b></td>
                      </tr>
                      <tr v-for="indicator in tbg.indicators" v-bind:key="indicator.id">
                        <td colspan="2">{{indicator.description}}</td>
                        <td style="width: 15%; text-align: center; vertical-align: middle;">{{indicator.type}}</td>
                      </tr>
                    </template>
                    <template v-if="tbg.hasObservation">
                      <tr>
                        <td style="background-color: #ededed; width: 15%;"><b>Observación:</b></td>
                        <td colspan="2">{{tbg.observation}}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
          <div v-if="loading">
            <b-card no-body img-right>
              <b-skeleton-img card-img="right" width="205px"></b-skeleton-img>
              <b-card-body>
                <b-skeleton-table
                  :rows="2"
                  :columns="2"
                  :table-props="{ bordered: true, striped: true }"
                ></b-skeleton-table>
              </b-card-body>
            </b-card>
            <b-skeleton-table
              :rows="5"
              :columns="2"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </div>
        </div>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import apiClient from '@/services/axios'
import axios from 'axios'
import store from 'store'
import moment from 'moment'
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import { consts, showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'GroupStudentReport',
  data() {
    return {
      currentYear: {},
      hasChildren: false,
      children: [],
      selectedChild: '',
      periodsList: [],
      periodSelected: {},
      report: {},
      loading: true,
      generatingReport: false,
    }
  },
  beforeRouteEnter (to, from, next) {
    const userStorage = JSON.parse(store.get('userData'))
    function getChildren() {
      if (userStorage.idRoles.includes(consts.roles.PADRE_MADRE)) {
        return apiClient.get(`/users/check-children/${userStorage.id}`)
      } else {
        return null
      }
    }

    function getPeriods() {
      return apiClient.get('/periods?maxPeriod=true')
    }

    function getYears() {
      return apiClient.get('/years')
    }

    axios.all([getChildren(), getPeriods(), getYears()])
      .then(axios.spread(function (children, periods, years) {
        next((vm) => {
          vm.setDataChildren(null, (children !== null) ? children.data : children)
          vm.setDataPeriods(null, periods.data.results.rows)
          vm.setDataYears(null, years.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataChildren(err, [])
          vm.setDataPeriods(err, [])
          vm.setDataYears(err, [])
        })
      })
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    setDataPeriods (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
        this.loading = false
      } else {
        this.periodsList = data
        if (data.length > 0) {
          this.selectPeriod(data[0])
        }
      }
    },
    setDataYears (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        for (const year of data) {
          if (year.current) {
            this.currentYear = year
          }
        }
      }
    },
    setDataChildren(err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else if (data !== null) {
        this.hasChildren = data.length > 0
        if (this.hasChildren) {
          this.children = data
          this.selectedChild = data[0].idChild
        }
      }
    },
    isVisible(sbg) {
      return sbg.iCans.length > 0
    },
    changeChild(value) {
      this.selectedChild = value
      this.selectPeriod(this.periodsList[0])
    },
    selectPeriod(period) {
      if (!period) {
        return
      }
      let idUser = this.$store.state.user.id
      this.loading = true // Data lista para renderizar
      this.periodSelected = period
      if (this.hasChildren) {
        idUser = this.selectedChild
      }
      apiClient.get(`/reports/academics/periods/${this.periodSelected.id}/students/${idUser}`).then(response => {
        this.report = response.data
        for (let i = 0; i < response.data.student.SBG.length; i++) {
          this.report.student.SBG[i].iCanListByStudent = [
            {
              id: 1,
              name: 'SER',
              data: [],
            },
            {
              id: 2,
              name: 'COGNITIVO',
              data: [],
            },
            {
              id: 3,
              name: 'METACOGNITIVO',
              data: [],
            },
          ]
          this.report.student.SBG[i].iCans.forEach(element => {
            if (element.dimension === 'SER') {
              this.report.student.SBG[i].iCanListByStudent[0].data.push(element)
            } else if (element.dimension === 'COGNITIVO') {
              this.report.student.SBG[i].iCanListByStudent[1].data.push(element)
            } else if (element.dimension === 'METACOGNITIVO') {
              this.report.student.SBG[i].iCanListByStudent[2].data.push(element)
            }
          })
          this.report.student.SBG[i].nICan = this.periodsList.length // Para hacer el rowspan
        }
        this.loading = false // Data lista para renderizar
      }).catch(e => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(e),
        })
      })
    },
    downloadGradesReport() {
      if (this.periodSelected === null) {
        Toast.fire({
          icon: 'warning',
          title: 'Seleccione un periodo válido',
        })
        return
      }
      let url = ''
      const checks = '?isAverage=false&periodSelected=' + this.periodSelected.id + '&indicatorsCheck=true&messageCheck=false'
      url = process.env.VUE_APP_API_URL + `/reports/academics/periods/student/${this.report.student.id}/qualifications${checks}`
      const endNameReport = this.report.student.fullName.replace(/\s/g, '_') + '_periodo_' + this.periodSelected.name.toLowerCase() + '_' + moment().format('YYYY_MM_DD')
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      this.generatingReport = true
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const filename = `Reporte_${endNameReport}.pdf`
        link.setAttribute('download', filename) // or any other extension
        document.body.appendChild(link)
        link.click()
        this.generatingReport = false
        Toast.fire({
          icon: 'success',
          title: 'Descarga finalizada...',
        })
        this.generatingReport = false
      }).catch(async (error) => {
        const responseObj = JSON.parse(await error.response.data.text())
        Toast.fire({
          icon: 'warning',
          title: responseObj.errors.msg,
        })
        this.generatingReport = false
      })
    },
  },
}
</script>
